/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * アシスタントの回答モード。省略時は developer_api（後方互換）。
 * 新規セッション開始時のみ参照され、agentId 指定時は無視される。
 * @export
 */
export const AgentAssistantMode = {
    DeveloperApi: 'developer_api',
    ProductUi: 'product_ui',
    WorkflowModeling: 'workflow_modeling'
} as const;
export type AgentAssistantMode = typeof AgentAssistantMode[keyof typeof AgentAssistantMode];


export function instanceOfAgentAssistantMode(value: any): boolean {
    for (const key in AgentAssistantMode) {
        if (Object.prototype.hasOwnProperty.call(AgentAssistantMode, key)) {
            if (AgentAssistantMode[key as keyof typeof AgentAssistantMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AgentAssistantModeFromJSON(json: any): AgentAssistantMode {
    return AgentAssistantModeFromJSONTyped(json, false);
}

export function AgentAssistantModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentAssistantMode {
    return json as AgentAssistantMode;
}

export function AgentAssistantModeToJSON(value?: AgentAssistantMode | null): any {
    return value as any;
}

export function AgentAssistantModeToJSONTyped(value: any, ignoreDiscriminator: boolean): AgentAssistantMode {
    return value as AgentAssistantMode;
}

